const translations = {
  status_active: 'Active',
  status_expired: 'Expired',
  status_alliance: 'Alliances',
  new: 'New',
  used: 'Used',
  images_real: 'Real image',
  images_stock: 'Stock image',
  images_empty: 'No images',
  price_empty: 'No price',
  filter_status: 'Status',
  filter_source: 'Source',
  filter_condition: 'Condition',
  filter_make: 'Make',
  filter_model: 'Model',
  filter_images: 'Images',
  filter_price: 'Price',
  filter_year: 'Year',
  filter_color: 'Color',
  filter_ext_color: 'Exterior color',
  filter_int_color: 'Interior color',
  filter_mileage: 'Mileage',
  filter_location: 'Location',
  filter_visibility: 'Visibility',
  more_filters: 'All filters',
  clear_filters: 'Clear',
  clear_filters_tooltip: 'Clear filters',
  mileage_from: 'From',
  mileage_to: 'Up to',
  price_from: 'From',
  price_to: 'Up to',
  year_from: 'From',
  year_to: 'Up to',
  close: 'Close',
  yes: 'Yes',
  no: 'No',
  from: 'From ',
  up_to: 'Up to ',
  filters: 'Filters',
  has_price: 'Has price',
  more_than_1_millon: 'More than $1,000,000',
  deal_status: 'Deal status',
  deal_status_Open: 'Open',
  deal_status_Done: 'Done',
  clear_all: 'Clear all',
};

export default translations;
